import {
    IStillImageBackgroundConfig,
    StillImageBackground
} from "@nolimitcity/slot-game/bin/game/background/StillImageBackground";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {SpacierArcadeGameConfig} from "../SpacierArcadeGameConfig";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {IGameModeChangedData} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {SpacierArcadeGameAssets} from "../SpacierArcadeGameAssets";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {TimelineLite} from "gsap";
import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {SpacierArcadeModeData} from "../server/data/SpacierArcadeModeData";
import {SpacierArcadeGameMode} from "../gamemode/SpacierArcadeGameMode";
import {SALayerConfig} from "../../config/SALayerConfig";
import {Translation} from "@nolimitcity/slot-game/bin/core/translation/Translation";
import {TextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/TextStyleOptions";
import {FontStyle, FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";

export class SAFreespinEvent{
    static readonly UPDATE_FREE_SPIN_COUNT: string = "saFreespinEvent_updateFreeSpinCount";
    static readonly UPDATE_BACK_IMAGE: string = "saFreespinEvent_updateBackImage";
}

export class SABackground extends StillImageBackground{
    private _backgroundSpine:PIXI.spine.Spine;
    private _backgroundSpinSpine:PIXI.spine.Spine;
    private _foregroundSpine:PIXI.spine.Spine;
    private _SA_DEFAULT_OFFSET:PIXI.Point = new PIXI.Point(350, 275);
    private _textContainer: PIXI.Container;
    private _stickyText: PIXI.Text;
    private _tempStyle:TextStyleOptions = {
        fontFamily : "Open Sans",
        fontSize : 26,
        fontWeight : FontWeight.SEMI_BOLD,
        align : "center",
        fill : [
            "#CAF96F"
        ]
    };
    private _tempSpinStyle:TextStyleOptions = {
        fontFamily : "Open Sans",
        fontSize : 26,
        fontWeight : FontWeight.SEMI_BOLD,
        align : "center",
        fill : [
            "#EC0AFF"
        ]
    };
    constructor(config:IStillImageBackgroundConfig) {
        super(config);
    }

    protected addEventListeners():void{
        super.addEventListeners();
        EventHandler.addEventListener(this, SAFreespinEvent.UPDATE_FREE_SPIN_COUNT, (event:GameEvent) => this.updateFreeSpinsLeftText(event.params[0]));
        EventHandler.addEventListener(this, SAFreespinEvent.UPDATE_BACK_IMAGE, (event:GameEvent) => this.updateBackImage(event.params[0]));
    }

    protected initAnimations():void {
        // super.initAnimations();
        // StageManager.getLayer(SALayerConfig.REEL_BACKGROUND.name).addChild(new PIXI.Sprite(GameResources.getTextures("reel/reelBackground")[0]));
        const backGroundLayer:ScalableLayer = StageManager.getLayer(SpacierArcadeGameConfig.instance.LAYERS.BACKGROUND.name);
        const reelBackGroundLayer:ScalableLayer = StageManager.getLayer(SpacierArcadeGameConfig.instance.LAYERS.SPIN_SPINE.name);
        const foreGroundLayer:ScalableLayer = StageManager.getLayer(SpacierArcadeGameConfig.instance.LAYERS.FOREGROUND_LAYER.name);
        this._backgroundSpine = new PIXI.spine.Spine(GameResources.getSpineAsset(SpacierArcadeGameAssets.BACKGROUND));
        this._backgroundSpine.autoUpdate = true;
        this._backgroundSpine.state.setAnimation(0, "bg_idle", true);
        this._backgroundSpine.x = this._SA_DEFAULT_OFFSET.x;
        this._backgroundSpine.y = this._SA_DEFAULT_OFFSET.y;
        backGroundLayer.addChild(this._backgroundSpine);

        this._backgroundSpinSpine = new PIXI.spine.Spine(GameResources.getSpineAsset(SpacierArcadeGameAssets.FG_EFFECTS));
        this._backgroundSpinSpine.autoUpdate = true;
        this._backgroundSpinSpine.alpha = 0;
        this._backgroundSpinSpine.position.set(GameConfig.instance.REEL_AREA_WIDTH * 0.5 + 20, GameConfig.instance.REEL_AREA_HEIGHT * 0.5);
        reelBackGroundLayer.addChild(this._backgroundSpinSpine);

        this._foregroundSpine = new PIXI.spine.Spine(GameResources.getSpineAsset(SpacierArcadeGameAssets.FG_IDLE));
        this._foregroundSpine.autoUpdate = true;
        this._foregroundSpine.state.setAnimation(0, "idle_main_game", true);
        this._foregroundSpine.position.set(GameConfig.instance.REEL_AREA_WIDTH * 0.5 + 20, GameConfig.instance.REEL_AREA_HEIGHT * 0.59);
        foreGroundLayer.addChild(this._foregroundSpine);

        this._textContainer = new PIXI.Container();
        let staticStickyFSText:PIXI.Text = new PIXI.Text(Translation.translate("3 1 2 5    W I N    W A Y S"), this._tempStyle);
        staticStickyFSText.anchor.set(0.5);
        staticStickyFSText.position.set(GameConfig.instance.REEL_AREA_WIDTH / 2, GameConfig.instance.REEL_AREA_POS_Y - 14);
        this._textContainer.addChild(staticStickyFSText);

        this._stickyText = new PIXI.Text(Translation.translate("0 S P I N S"), this._tempSpinStyle);
        this._stickyText.anchor.set(0.5);
        this._stickyText.position.set(GameConfig.instance.REEL_AREA_WIDTH - this._stickyText.width/1.75, GameConfig.instance.REEL_AREA_POS_Y - 14);
        this._textContainer.addChild(this._stickyText);
        this._textContainer.alpha = 0;
        foreGroundLayer.addChild(this._textContainer);
    }

    protected updateFreeSpinsLeftText(freeSpinsLeft:number):void{
        if(freeSpinsLeft > 1){
            this._stickyText.text = Translation.translate(freeSpinsLeft + " " + "  S P I N S");
        }
        else {
            this._stickyText.text = Translation.translate(freeSpinsLeft + " " + "  S P I N");
        }
    }

    protected onChangeBackground(data:IGameModeChangedData):boolean {
        let shouldChange:boolean = !((SpacierArcadeModeData.instance.isMainGame && (data.newMode === SpacierArcadeGameMode.NORMAL || data.newMode === SpacierArcadeGameMode.RESPIN)) ||
            (SpacierArcadeModeData.instance.isFreespin && (data.newMode === SpacierArcadeGameMode.FREESPIN_RESPIN || data.newMode === SpacierArcadeGameMode.FREESPIN))) ||
            (SpacierArcadeModeData.instance.isRestore && (data.newMode === SpacierArcadeGameMode.FREESPIN_RESPIN || data.newMode === SpacierArcadeGameMode.FREESPIN))
        if(shouldChange) {
            let animName: string = (data.newMode === SpacierArcadeGameMode.NORMAL || data.newMode === SpacierArcadeGameMode.RESPIN) ? "bg_idle" : "bg_fs";
            this._backgroundSpine.state.setAnimation(0, animName, true);
            if(animName === "bg_fs"){
                this._textContainer.alpha = 1;
                this._backgroundSpine.state.setAnimation(1, "bg_fs_track_01", true);
            }
            else{
                this._textContainer.alpha = 0;
            }
            this._backgroundSpine.state.setAnimation(0, animName, true);
            let animFGName: string = (data.newMode === SpacierArcadeGameMode.NORMAL || data.newMode === SpacierArcadeGameMode.RESPIN) ? "idle_main_game" : "idle_fs";
            this._foregroundSpine.state.setAnimation(0, animFGName, true);
        }
        return true;
    }

    private updateBackImage(playAnim:boolean):void{
        if(playAnim) {
            this._backgroundSpine.state.setAnimation(1, "idle_logo", true);
            this._backgroundSpine.state.tracks[1].alpha = 1;
        }
        else{
            if(this._backgroundSpine.state.tracks[1] !== undefined) {
                this._backgroundSpine.state.tracks[1].alpha = 0;
            }
        }
    }

    protected triggerSpinEffect():void{
        if(!(SpacierArcadeModeData.instance.mode === SpacierArcadeGameMode.FREESPIN || SpacierArcadeModeData.instance.mode === SpacierArcadeGameMode.FREESPIN_RESPIN)) {
            let spinTimeLine: TimelineLite = new TimelineLite({paused: true});
            spinTimeLine.add(() => this._backgroundSpinSpine.alpha = 1);
            spinTimeLine.add(new SpineTween(this._backgroundSpinSpine, 0, "spin_5x3"));
            spinTimeLine.add(() => this._backgroundSpinSpine.alpha = 0);
            spinTimeLine.play();
        }
    }

}